import _ from "underscore";
import template from "./template";

export default function groupBy(baseArray = [], fn) {
  return _.chain(baseArray)
    .groupBy(item => template(item, fn, {}))
    .pairs()
    .value();
}
